import * as React from "react"
import { Building2, GitBranch, History, LayoutGrid, ShieldCheck, Users } from "lucide-react"
import { AppShell } from "@/components/AppShell"
import { cn } from "@/lib/utils"
import { Link, usePage } from "@inertiajs/react"

const items = [
  ["/company/settings", "Company", Building2],
  ["/company/settings/branches", "Branches", GitBranch],
  ["/company/settings/members", "Team", Users],
  ["/company/settings/roles", "Roles & permissions", ShieldCheck],
  ["/company/settings/modules", "Modules", LayoutGrid],
  ["/company/settings/audit_events", "Audit activity", History],
] as const

export function CompanySettingsShell({ children }: { children: React.ReactNode }) {
  const { url } = usePage()
  return (
    <AppShell>
      <header className="border-b border-hairline pb-5">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-accent-display">Company control</p>
        <h1 className="mt-2">Settings</h1>
        <p className="mt-1 text-sm text-ink-muted">Identity, access and operating complexity for this company.</p>
      </header>
      <nav className="-mx-1 mt-5 flex gap-1 overflow-x-auto pb-2" aria-label="Company settings">
        {items.map(([href, label, Icon]) => {
          const active = href === "/company/settings" ? url === href : url.startsWith(href)
          return <Link key={href} href={href} className={cn("flex shrink-0 items-center gap-2 rounded-md px-3 py-2 text-sm no-underline", active ? "bg-accent-faded font-medium text-accent-display" : "text-ink-muted hover:bg-surface hover:text-ink-display")}><Icon className="h-4 w-4" />{label}</Link>
        })}
      </nav>
      <div className="mt-6">{children}</div>
    </AppShell>
  )
}
